import React from 'react';
import PropTypes from 'prop-types';
import { Avatar } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import VuiTypography from "components/VuiTypography";
import VuiBox from "components/VuiBox";

const FriendCard = ({ friend }) => {
  const { t } = useTranslation();

  return (
    <Link to={`/user/${friend.id}`} style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
      <VuiBox
        sx={{
          display: 'flex',
          alignItems: 'center',
          padding: '12px 16px',
          background: "linear-gradient(126.97deg, rgba(6,11,40,0.92) 28.26%, rgba(10,14,35,0.85) 91.2%)",
          border: "1px solid rgba(255,255,255,0.07)",
          borderRadius: "12px",
          transition: "transform 0.18s ease, box-shadow 0.18s ease",
          "&:hover": {
            transform: "translateY(-2px)",
            boxShadow: "0 6px 20px rgba(0,117,255,0.15)",
          },
        }}
      >
        <Avatar
          alt={friend.name}
          src={friend.avatar}
          sx={{ width: { xs: 48, sm: 56 }, height: { xs: 48, sm: 56 }, flexShrink: 0 }}
        />
        <VuiBox sx={{ ml: 2, minWidth: 0 }}>
          <VuiTypography variant="h6" color="white" fontWeight="bold" noWrap>
            {friend.display_name}
          </VuiTypography>
          <VuiTypography variant="caption" sx={{ color: '#a0aec0' }} noWrap>
            {friend.name}
          </VuiTypography>
        </VuiBox>
      </VuiBox>
    </Link>
  );
};

FriendCard.propTypes = {
  friend: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    avatar: PropTypes.string.isRequired,
    display_name: PropTypes.string.isRequired,
  }).isRequired,
};

export default FriendCard;
